/*
 * Labels both screens print the same way. How a course's kind is named: The backend's kinds are `flex`
 * and `credit`; "credit" is its billing term, and the ops team and the design
 * call the second one non-flex.
 */

import { toDisplayDate } from "./timings";

/**
 * @param {boolean} isFlex
 * @returns {"Flex"|"Non-flex"}
 */
export const courseTypeLabel = (isFlex) => (isFlex ? "Flex" : "Non-flex");

/**
 * The same kind as the "Type:" fact in a strip spells it — the design capitalises
 * it there ("Type: Non-Flex") and not in the course list.
 * @param {boolean} isFlex
 * @returns {"Flex"|"Non-Flex"}
 */
export const courseTypeStripLabel = (isFlex) => (isFlex ? "Flex" : "Non-Flex");

/**
 * A weekly class count as the strips print it.
 * @param {number|null|undefined} count
 * @returns {string|null} "1 class / week", "3 classes / week"; null with no count
 */
export const perWeekLabel = (count) =>
  count === null || count === undefined ? null : `${count} ${Number(count) === 1 ? "class" : "classes"} / week`;

/**
 * The line under a course's name in a course list, as the design writes it:
 * "Non-flex | 48 sessions | 3 classes per week". A course bought twice adds its
 * purchase date, which is all that tells the two apart.
 * @param {Object} course - an E1 `courses[]` row
 * @param {boolean} isDuplicate - the same course is listed more than once
 * @returns {string}
 */
export const courseMeta = (course, isDuplicate) => {
  const isFlex = course?.kind === "flex";
  const parts = [
    courseTypeLabel(isFlex),
    isFlex
      ? course?.durationMonths && `${course?.durationMonths} months`
      : course?.sessions && `${course?.sessions} sessions`,
    course?.weeklyFrequency && `${course?.weeklyFrequency} classes per week`,
    isDuplicate && course?.purchasedOn && `bought ${toDisplayDate(course?.purchasedOn)}`,
  ];
  return parts.filter(Boolean).join(" | ");
};
